<div class="cards-container">
    <ng-container *ngFor="let contract of contracts">
        <div class="animated-col d-flex">
            <div class="contract-card flex-grow-1 ccc ccc-hover" role="button" (click)="viewDetailsHandler(contract.externalEntityId)">      
                @switch (contract.dictionaryContractType.code) {
                    @case (ContractType.FINANCIAL_LEASING) {
                        <div class="card-details text-ellipsis">
                            <dynamic-field [props]="props?.Number" [canBeEmpty]="true">
                                <span HJSuppress class="number fw-bold">{{contract.number}}</span>
                            </dynamic-field>
                            <div HJSuppress class="fs-5">{{'contracts.contractType.financialLeasing' | translate}}</div>
                        </div>
                        <div class="card-value">
                            <dynamic-field [props]="props?.OutstandingAmount" [canBeEmpty]="true">
                                <div class="d-flex flex-column">
                                    <span class="fs-5 card-label fw-semibold">{{('outstandingAmount.financialLeasing' | translate)}}</span>
                                    <span HJSuppress class="fs-4 fw-bold">
                                        {{ contract.outstandingAmount | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                                    </span>
                                </div>
                            </dynamic-field>
                            <dynamic-field [props]="props?.ResidualValue" [canBeEmpty]="true">
                                <div class="card-label mb-3">
                                    <span>{{'contracts.residualValue' | translate}}</span>
                                    <span HJSuppress class="fw-semibold"> 
                                        {{ contract.residualValue | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                                    </span>
                                </div>
                            </dynamic-field>
                            <dynamic-field [props]="props?.NextPayment" [canBeEmpty]="true">
                                <div class="d-flex flex-column">
                                    <span class="fs-5 card-label fw-semibold">{{'contracts.nextInstallmentAmount' | translate}}</span>
                                    <span HJSuppress class="fs-4 fw-bold">
                                        {{ contract.nextPayment | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                                    </span>
                                </div>
                            </dynamic-field>
                            <dynamic-field [props]="props?.TotalInstallmentsNumber" [canBeEmpty]="true">
                                <div class="card-label">
                                    <span>{{'contracts.installments' | translate}}</span>
                                    <span HJSuppress class="fw-semibold"> 
                                        <span class="text-primary">
                                            {{contract.paidInstallmentsNumber}}
                                        </span>
                                        /
                                        <span>
                                            {{contract.totalInstallmentsNumber}}
                                        </span>
                                    </span>
                                </div>
                            </dynamic-field>
                            <ng-container *ngTemplateOutlet="overdueAmount ; context: {contract: contract}">
                            </ng-container>
                        </div>
                    }
                    @case (ContractType.CREDIT) {
                        <div class="card-details text-ellipsis">
                            <dynamic-field [props]="props?.Number" [canBeEmpty]="true">
                                <span HJSuppress class="number fw-bold">{{contract.number}}</span>
                            </dynamic-field>
                            <div HJSuppress class="fs-5">{{'contracts.contractType.credit' | translate}}</div>     
                        </div>
                        <div class="card-value">
                            <dynamic-field [props]="props?.OutstandingAmount" [canBeEmpty]="true">
                                <div class="d-flex flex-column">
                                    <span class="fs-5 card-label fw-semibold">{{('outstandingAmount.credit' | translate)}}</span>
                                    <span HJSuppress class="fs-4 fw-bold">
                                        {{ contract.outstandingAmount | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                                    </span>
                                </div>
                            </dynamic-field>
                            <dynamic-field [props]="props?.Balloon" [canBeEmpty]="true">
                                <div *ngIf="contract.balloon || contract.balloon === 0" class="card-label mb-3">
                                    <span>{{'contracts.balloonPayment' | translate}}</span>
                                    <span HJSuppress class="fw-semibold"> 
                                        {{ contract.balloon | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                                    </span>
                                </div>
                            </dynamic-field>
                            <dynamic-field [props]="props?.NextPayment" [canBeEmpty]="true">
                                <div class="d-flex flex-column">
                                    <span class="fs-5 card-label fw-semibold">{{'contracts.nextInstallmentAmount' | translate}}</span>
                                    <span HJSuppress class="fs-4 fw-bold">
                                        {{ contract.nextPayment | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                                    </span>
                                </div>
                            </dynamic-field>
                            <dynamic-field [props]="props?.TotalInstallmentsNumber" [canBeEmpty]="true">
                                <div class="card-label">
                                    <span>{{'contracts.installments' | translate}}</span>
                                    <span HJSuppress class="fw-semibold"> 
                                        <span class="text-primary">
                                            {{contract.paidInstallmentsNumber}}
                                        </span>
                                        /
                                        <span>
                                            {{contract.totalInstallmentsNumber}}
                                        </span>
                                    </span>
                                </div>
                            </dynamic-field>
                            <ng-container *ngTemplateOutlet="overdueAmount; context: {contract: contract}">
                            </ng-container>
                        </div>
                    }
                    @case (ContractType.OPERATIONAL_LEASING) {
                        <div class="card-details text-ellipsis">
                            <dynamic-field [props]="props?.Number" [canBeEmpty]="true">
                                <span HJSuppress class="number fw-bold">{{contract.number}}</span>
                            </dynamic-field>
                            <div HJSuppress class="fs-5">{{'contracts.contractType.operationalLeasing' | translate}}</div>
                        </div>
                        <div class="card-value">
                            <dynamic-field [props]="props?.NextPayment" [canBeEmpty]="true">
                                <div class="d-flex flex-column">
                                    <span class="fs-5 card-label fw-semibold">{{'contracts.nextInstallmentAmount' | translate}}</span>
                                    <span HJSuppress class="fs-4 fw-bold">
                                        {{ contract.nextPayment | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                                    </span>
                                </div>
                            </dynamic-field>
                            <dynamic-field [props]="props?.TotalInstallmentsNumber" [canBeEmpty]="true">
                                <div class="card-label">
                                    <span>{{'contracts.installments' | translate}}</span>
                                    <span HJSuppress class="fw-semibold"> 
                                        <span class="text-primary">
                                            {{contract.paidInstallmentsNumber}}
                                        </span>
                                        /
                                        <span>
                                            {{contract.totalInstallmentsNumber}}
                                        </span>
                                    </span>
                                </div>
                            </dynamic-field>
                            <ng-container *ngTemplateOutlet="overdueAmount; context: {contract: contract}">
                            </ng-container>
                        </div>
                    }
                }
                <div class="card-date">
                    <div class="date-label">
                        {{'contracts.contractPeriod' | translate}}
                    </div>
                    <div class="d-flex align-items-center justify-content-center gap-3">
                        <dynamic-field [props]="props?.SigningDate" [canBeEmpty]="true">
                            <div HJSuppress class="fw-bold">{{contract.signingDate | localizedDate}}</div>
                        </dynamic-field>
                        <i class="app-icon icon icon-arrow-right icon-lg"></i>
                        <dynamic-field [props]="props?.TerminationDate" [canBeEmpty]="true">
                            <div HJSuppress class="fw-bold">{{contract.terminationDate | localizedDate}}</div>
                        </dynamic-field>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #overdueAmount let-contract="contract">
    <dynamic-field [props]="props?.OverdueAmounts" [canBeEmpty]="true">
        <div *ngIf="contract.hasOverdue" class="d-flex justify-content-center align-items-center gap-1">
            <span class="state"><i class="app-icon icon icon-warning-triangle-fill icon-lg overdue-icon me-1"></i></span>
            <span class="card-label">{{'contracts.overdueAmount' | translate}}:</span>
            <span HJSuppress class="overdue-color fw-semibold">{{contract.overdueAmountsString}}</span>
        </div>
    </dynamic-field>
</ng-template>


